import theme from 'config/theme';
import {Icon} from 'interface/base/Icon';
import Typography from 'interface/base/Typography';
import React from 'react';
import {StyleSheet, View, useWindowDimensions} from 'react-native';
import LinearGradient from 'react-native-web-linear-gradient';

export default function MediaFireInfo() {
  const dimension = useWindowDimensions();
  const isMobile = dimension.width <= 1024;
  return (
    <View style={[styles.root, isMobile && styles.rootMobile]}>
      {/* Heading */}
      <View style={styles.heading}>
        <View style={styles.bannerContent}>
          <View style={styles.bannerIcon}>
            {/* biome-ignore lint/a11y/noSvgWithoutTitle: ignore */}
            <svg
              width="37"
              height="20"
              viewBox="0 0 37 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M32.8469 3.19904C30.791 1.43095 27.9882 0.59904 25.2994 0.48904C22.7791 0.329972 20.2693 0.93306 18.1 2.21904C17.9353 2.3238 17.7749 2.43428 17.6184 2.54999C18.2214 2.35591 18.85 2.25208 19.4837 2.2419C20.5734 2.23856 21.4591 2.98618 21.462 3.91237C21.4649 4.83857 20.5839 5.59142 19.4942 5.59476C18.068 5.59952 16.6599 5.11809 15.2676 4.86238C13.7959 4.57593 12.301 4.42371 10.8015 4.40761C6.00991 4.40761 4.53336 6.86809 4.53336 6.86809L4.94367 6.55857C5.35038 6.22387 5.82854 5.98592 6.34171 5.86285C6.57532 5.82313 6.81557 5.8643 7.02234 5.9795C7.22911 6.0947 7.3899 6.27695 7.47786 6.49584C7.56583 6.71473 7.57564 6.957 7.50567 7.18221C7.4357 7.40743 7.29017 7.60196 7.09339 7.73333C5.29318 8.84809 2.36306 8.39142 0.886505 12.4576C1.0821 12.035 1.38425 11.6698 1.76363 11.3976C2.74582 10.7503 3.87251 10.3522 5.04518 10.2381C6.63324 9.98812 8.25611 10.0674 9.81189 10.4709C10.7043 10.7114 11.7371 11.049 12.2498 11.8757C12.6812 12.5719 12.6836 13.5257 11.8572 13.92C11.2361 14.1838 10.561 14.2977 9.88706 14.2524L9.85977 14.2514C11.591 14.4794 13.2896 14.9077 14.9209 15.5276C17.7194 16.7114 20.3177 18.3676 23.2924 19.1152C25.5696 19.7409 27.9855 19.6532 30.2107 18.8638C31.7164 18.2633 33.0414 17.2876 34.0583 16.0305C35.0752 14.7734 35.7496 13.2771 36.0169 11.6857C36.2428 10.1204 36.0711 8.52377 35.5175 7.04139C34.9639 5.55901 34.0459 4.23807 32.8474 3.19904H32.8469ZM12.245 11.819L12.234 11.8057L12.2067 11.7757L12.234 11.8057L12.246 11.8186L12.245 11.819ZM31.5101 9.69047C31.6112 10.1807 31.6141 10.686 31.5187 11.1773C31.4233 11.6687 31.2316 12.1365 30.9543 12.5542C30.6771 12.9718 30.3199 13.331 29.903 13.6113C29.4862 13.8916 29.0179 14.0874 28.525 14.1876C24.7215 14.9605 20.3857 11.8195 17.0448 10.2852C22.7131 10.6271 24.3601 7.2538 26.989 6.7219C27.9844 6.51979 29.0197 6.71899 29.8674 7.27572C30.7152 7.83245 31.306 8.70116 31.5101 9.69095V9.69047Z"
                fill="#4868FA"
              />
            </svg>
          </View>
          <LinearGradient
            colors={['#4868FA', '#8C35E4', '#EC348D']}
            start={{x: 0, y: 0.5}}
            end={{x: 1, y: 0.5}}
            style={styles.bannerText}>
            Powered by MediaFire
          </LinearGradient>
        </View>
        <Typography
          size="xl"
          variant="semi-bold"
          color={theme.colors.neutral.$2Base}
          overrides={styles.headingText}>
          Unlimited Storage and AI Chat for Teams and Businesses
        </Typography>
      </View>

      {/* Features */}
      <View style={styles.features}>
        <View style={styles.featureItem}>
          <View
            style={[
              styles.featureIconBg,
              {backgroundColor: 'rgba(72,104,250,0.12)'},
            ]}>
            <Icon
              name="lucide:layout-panel-left"
              size={20}
              color={theme.colors.brand.$4}
            />
          </View>
          <View style={styles.featureText}>
            <Typography
              size="md"
              variant="semi-bold"
              color={theme.colors.neutral.$2Base}>
              Project-Level Cloud Storage
            </Typography>
            <Typography size="sm" color={theme.colors.neutral.$2Base}>
              Easily organize files by team or project. Everyone always has
              access to the right content.
            </Typography>
          </View>
        </View>
        <View style={styles.featureDivider} />
        <View style={styles.featureItem}>
          <View
            style={[
              styles.featureIconBg,
              {backgroundColor: 'rgba(72,104,250,0.12)'},
            ]}>
            <Icon
              name="lucide:share-2"
              size={20}
              color={theme.colors.brand.$4}
            />
          </View>
          <View style={styles.featureText}>
            <Typography
              size="md"
              variant="semi-bold"
              color={theme.colors.neutral.$2Base}>
              Professional Sharing
            </Typography>
            <Typography size="sm" color={theme.colors.neutral.$2Base}>
              Customizable Shares create secure data rooms, enable secure,
              efficient file sharing with granular control.
            </Typography>
          </View>
        </View>
        <View style={styles.featureDivider} />
        <View style={styles.featureItem}>
          <View
            style={[
              styles.featureIconBg,
              {backgroundColor: 'rgba(72,104,250,0.12)'},
            ]}>
            <Icon name="lucide:cpu" size={24} color={theme.colors.brand.$4} />
          </View>
          <View style={styles.featureText}>
            <Typography
              size="md"
              variant="semi-bold"
              color={theme.colors.neutral.$2Base}>
              Instant AI Insights
            </Typography>
            <Typography size="sm" color={theme.colors.neutral.$2Base}>
              Chat with AI as a team, gain insights, create automated workflows,
              and analyze all your data.
            </Typography>
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    height: '100%',
    minWidth: 300,
    maxWidth: 500,
    backgroundColor: theme.colors.neutral.$16,
    borderTopRightRadius: 16,
    borderBottomRightRadius: 16,
    paddingHorizontal: 48,
    paddingVertical: 72,
    gap: 48,
    overflow: 'hidden',
    alignItems: 'center',
    position: 'relative',
  },
  rootMobile: {
    maxWidth: '100%',
    borderTopLeftRadius: 16,
    borderBottomLeftRadius: 16,
    paddingHorizontal: 24,
    paddingVertical: 24,
    gap: 24,
  },
  bannerGradient: {
    marginTop: 12,
    borderRadius: 999,
    paddingVertical: 10,
    paddingHorizontal: 28,
    alignSelf: 'flex-start',
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 4},
    shadowOpacity: 0.18,
    shadowRadius: 12,
    elevation: 8,
  },
  bannerContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  bannerIcon: {
    width: 37,
    height: 20,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 8,
  },
  bannerText: {
    fontSize: 11,
    fontWeight: '600',
    lineHeight: 14,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    backgroundClip: 'text',
    color: 'transparent',
  },
  heading: {
    zIndex: 1,
    alignSelf: 'flex-start',
    gap: 16,
  },
  headingText: {
    textAlign: 'left',
    fontSize: 20,
    fontWeight: '600',
    lineHeight: 30,
    maxWidth: '350px',
  },
  features: {
    width: '100%',
    zIndex: 1,
  },
  featureItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  featureDivider: {
    borderBottomWidth: 1,
    borderBottomColor: '#e5e8ef',
    borderStyle: 'dotted',
    width: '100%',
    marginVertical: 20,
  },
  featureIconBg: {
    width: 36,
    height: 36,
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  featureText: {
    flex: 1,
  },
});
